import type { UseHandleEditClick } from 'hooks/types';
import { webEditor } from 'utils/endpoints';

const useHandleEditClick: UseHandleEditClick = (isMobile, isTargetBlank) => {
  return (itemId, ev, itemType) => {
    if (isTargetBlank) {
      window.open(webEditor.createInternal(itemId, itemType), '_blank');
    } else {
      window.location.href = webEditor.createInternal(itemId, itemType);
    }
  };
};

export default useHandleEditClick;
